import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Capital Blue Cross",
  shortName: "Capital Blue Cross",
  slug: "capbluecross-insurance",
  seoTitle: "Capital Blue Cross TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Capital Blue Cross policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Capital Blue Cross TMS coverage, Capital Blue Cross SPRAVATO authorization, Capital Blue Cross mental health benefits Coral Springs FL, Capital Blue Cross depression treatment Florida",
};

export const CapBlueCrossInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default CapBlueCrossInsurance;
